module.exports = __webpack_public_path__ + "static/media/imageNotFound.2b87795a.png";